module.exports = __webpack_public_path__ + "ce500c73ce9bcc7919c6232299e24892.png";